<header mat-dialog-title>
  <nav *ngIf="showNav">
    <button (click)="showTerms = true" [class.active]="showTerms === true">Terms of Service</button>
    <button (click)="showTerms = false" [class.active]="showTerms === false">Privacy Policy</button>
  </nav>
  <div>
    <button mat-button [mat-dialog-close]="true">Close</button>
  </div>
</header>
<mat-dialog-content>
  <app-terms-of-use-page *ngIf="showTerms; else privacy"></app-terms-of-use-page>
  <ng-template #privacy>
    <app-privacy-policy-page *ngIf="!data?.privacyPolicyContent else privacyElseBlock"
                             [showSectionNav]="false"></app-privacy-policy-page>
    <ng-template #privacyElseBlock>
      <div class="text-indent" [innerHTML]="data?.privacyPolicyContent"></div>
    </ng-template>
  </ng-template>
</mat-dialog-content>
